const urlParams = new URLSearchParams(window.location.search);
const key = urlParams.get('key');

// const connString = 'http://localhost:4000';
const connString = 'https://api.westerninterlock.com';

const apolloLink = `${connString}/graphql?key=${key}`;

export { connString, apolloLink, key };
